import ApiClient from "@/api/ApiClient.ts";
import { wgId } from "@/store/getters";
import qs from "qs";

const CONFIGS_PATH = "configs";
const GENERAL_SETTINGS_WG = "generalSettingsWg";

interface GeneralSettings {
  [key: string]: any;
}

interface Config {
  [key: string]: any;
}

interface ApiResponse<T> {
  data: T;
}

export async function getGeneralSettings(workgroupId: string): Promise<GeneralSettings> {
  const params = {
    idWg: workgroupId,
    name: GENERAL_SETTINGS_WG,
  };
  return await ApiClient()
    .get<GeneralSettings>(`${CONFIGS_PATH}`, { params })
    .then((response: ApiResponse<GeneralSettings>) => response.data);
}

export async function saveGeneralSettings(
  workgroupId: string,
  data: Partial<GeneralSettings>
): Promise<any> {
  const params = {
    idWg: workgroupId,
    name: GENERAL_SETTINGS_WG,
  };
  const current = await getGeneralSettings(workgroupId);
  const updated = { ...current, ...data };
  const urlFormData = qs.stringify({ value: JSON.stringify(updated) });
  return await ApiClient().put(`${CONFIGS_PATH}`, urlFormData, {
    params,
    headers: { "content-type": "application/x-www-form-urlencoded" },
  });
}

export async function getConfigByName(idWg: string, name: string): Promise<Config> {
  return await ApiClient()
    .get<Config>("configs", { params: { idWg, name } })
    .then((response: ApiResponse<Config>) => response.data);
}

export async function getCentralConfigByName(
  idWg: string,
  idCentral: string,
  name: string
): Promise<Config> {
  return await ApiClient()
    .get<Config>("configs", { params: { idWg, idCentral, name } })
    .then((response: ApiResponse<Config>) => response.data);
}

export async function updateConfigByName(
  idWg: string,
  name: string,
  config: Config
): Promise<boolean> {
  const params = {
    idWg,
    name,
  };
  const urlFormData = qs.stringify({ value: JSON.stringify(config) });
  try {
    const api = ApiClient();
    await api.put("configs", urlFormData, {
      params,
      headers: { "content-type": "application/x-www-form-urlencoded" },
    });
    return true;
  } catch (error: any) {
    console.error("ERROR en updateConfigs: ", error.message);
    return false;
  }
}

export async function updateCentralConfigByName(
  idWg: string,
  idCentral: string,
  name: string,
  config: Config
): Promise<boolean> {
  const params = {
    idWg,
    idCentral,
    name,
  };
  const urlFormData = qs.stringify({ value: JSON.stringify(config) });
  try {
    const api = ApiClient();
    await api.put("configs", urlFormData, {
      params,
      headers: { "content-type": "application/x-www-form-urlencoded" },
    });
    return true;
  } catch (error: any) {
    console.error("ERROR en updateConfigs: ", error.message);
    return false;
  }
}

export async function getGeneralSettingsWg(idWg: string): Promise<Config> {
  return await getConfigByName(idWg, "generalSettingsWg");
}

export async function updateGeneralSettingsWg(idWg: string, config: Config): Promise<boolean> {
  return await updateConfigByName(idWg, "generalSettingsWg", config);
}

export async function getCalendarsConfig(idWg: string, idCentral: string): Promise<Config> {
  return await getCentralConfigByName(idWg, idCentral, "calendars");
}

export async function saveCalendarsConfig(
  idWg: string,
  idCentral: string,
  config: Config
): Promise<boolean> {
  return await updateCentralConfigByName(idWg, idCentral, "calendars", config);
}
